import { render, staticRenderFns } from "./orderdetila.vue?vue&type=template&id=ff41b78c&scoped=true"
import script from "./orderdetila.vue?vue&type=script&lang=js"
export * from "./orderdetila.vue?vue&type=script&lang=js"
import style0 from "./orderdetila.vue?vue&type=style&index=0&id=ff41b78c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff41b78c",
  null
  
)

export default component.exports